module.exports = __webpack_public_path__ + "static/img/57.c7988c06.png";